import { ErrorMessages, ErrorType } from 'constants/errors';

export const ErrorMessagesMap = {
  [ErrorType.INVALID_EMAIL]: ErrorMessages.AUTH.INVALID_DATA,
  [ErrorType.INVALID_PASSWORD]: ErrorMessages.AUTH.INVALID_DATA,
  [ErrorType.VALIDATION_FAILED]: ErrorMessages.AUTH.INVALID_DATA,
  [ErrorType.INVALID_AUTH_DATA]: ErrorMessages.AUTH.INVALID_DATA,
  [ErrorType.INVALID_CREDENTIALS]: ErrorMessages.AUTH.INVALID_DATA,
};

export const CredentialErrors = [
  ErrorType.INVALID_EMAIL,
  ErrorType.INVALID_PASSWORD,
  ErrorType.VALIDATION_FAILED,
  ErrorType.INVALID_AUTH_DATA,
  ErrorType.INVALID_CREDENTIALS,
];
